<template>
    <ServicePageLayout
        title="Редизайн сайтов"
        description="Обновляю внешний вид и структуру существующих сайтов. Помогаю сделать проект современнее, удобнее для пользователей и визуально сильнее."
        :includes="includes"
        :audience="audience"
        :steps="steps"
        price="Стоимость редизайна сайта — от 15 000 ₽. Сроки — от 1 недели."
    />
</template>

<script setup>
import ServicePageLayout from '@/components/cards/ServicePageLayout.vue';

const includes = [
    'анализ текущего сайта и его структуры',
    'обновление визуального оформления',
    'улучшение типографики, цветов и блоков',
    'адаптация под мобильные устройства',
    'доработка интерфейса и пользовательского пути',
];

const audience = [
    'сайтам с устаревшим дизайном',
    'проектам с неудобной структурой',
    'бизнесу, которому нужно повысить доверие клиентов',
    'сайтам, которые плохо выглядят на мобильных устройствах',
];

const steps = [
    'аудит текущего сайта',
    'согласование новой структуры',
    'обновление дизайна и интерфейса',
    'вёрстка и внедрение изменений',
    'проверка результата и публикация',
];
</script>